<button mat-icon-button [matTooltip]="tooltip" [color]="color" (click)="onClick()">
    <img src="assets/images/Dummy_QR.png" alt="Button Image" height="10">
</button>
